var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgText = function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Text_svg__Text_svg__clip0_1593_13068)",
    stroke: "#1E1E5C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 2a2 2 0 00-2 2v8a2 2 0 002 2M4 2a2 2 0 012 2v8a2 2 0 01-2 2m4.666-9.333h4.667a.667.667 0 01.666.666v5.333a.667.667 0 01-.666.667H8.666M3.333 4.667h-.666A.667.667 0 002 5.333v5.333a.667.667 0 00.667.667h.666M11.334 8h.007M8.666 8h.007"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Text_svg__Text_svg__clip0_1593_13068"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgText;